import { render, staticRenderFns } from "./invoiceConfigInfoBox.vue?vue&type=template&id=31c8e7ea&"
import script from "./invoiceConfigInfoBox.vue?vue&type=script&lang=ts&"
export * from "./invoiceConfigInfoBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports